import React, { useState, useRef, useEffect } from 'react';
import EmojiPicker from 'emoji-picker-react';

export const MessageInput = ({ chatId, socket }) => {
    const [message, setMessage] = useState('');
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const emojiPickerRef = useRef(null);
    const emojiButtonRef = useRef(null); // Track emoji button
    const userId = JSON.parse(localStorage.getItem('data'))?.id;

    const sendMessage = async () => {
        if (!message.trim()) return;

        const newMessage = {
            chat_id: chatId,
            sender_id: userId,
            message,
        };

        try {
            if (message.trim()) {
                socket.emit('sendMessage', newMessage);
                setMessage(''); // Clear the message after sending
            }
        } catch (error) {
            console.error("Error sending message:", error);
        }
    };

    // Handle emoji click
    const handleEmojiClick = (emoji) => {
        setMessage((prevMessage) => prevMessage + emoji.emoji);
    };

    // Handle Enter key press
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            sendMessage();
        }
    };

    // Close emoji picker if clicked outside (but not on the emoji button)
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                emojiPickerRef.current &&
                !emojiPickerRef.current.contains(e.target) &&
                emojiButtonRef.current &&
                !emojiButtonRef.current.contains(e.target) // Ignore emoji button click
            ) {
                setShowEmojiPicker(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <div className="p-3 border-t border-gray-300 flex items-center relative bg-white">

            {/* Emoji Button */}
            <button
                ref={emojiButtonRef} // Attach ref to button
                className="p-2"
                onClick={() => setShowEmojiPicker((prev) => !prev)}
            >
                <span role="img" aria-label="emoji">😊</span>
            </button>

            {/* Emoji Picker */}
            {showEmojiPicker && (
                <div
                    ref={emojiPickerRef}
                    className="absolute bottom-16 left-1/4 transform -translate-x-1/2 z-10 bg-white shadow-lg p-2 rounded-md"
                >
                    <EmojiPicker onEmojiClick={handleEmojiClick} />
                </div>
            )}

            {/* Message Input */}
            <textarea
                className="flex-1 p-2 border rounded-md resize-none overflow-hidden !m-0"
                placeholder="Type a message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                rows={1} // Starts with 1 row
                style={{ minHeight: "40px", maxHeight: "200px" }} // Adjust max height as needed
                onKeyDown={handleKeyDown}
            />

            {/* Send Button */}
            <button
                className="ml-2 px-4 py-2 bg-[#8ec639] text-white rounded-md"
                onClick={sendMessage}
            >
                <i className='fa fa-paper-plane'></i>
            </button>
        </div>
    );
};
